import { render, staticRenderFns } from "./news-item.vue?vue&type=template&id=ad92e2ac&scoped=true&"
import script from "./news-item.vue?vue&type=script&lang=ts&"
export * from "./news-item.vue?vue&type=script&lang=ts&"
import style0 from "./news-item.vue?vue&type=style&index=0&id=ad92e2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad92e2ac",
  null
  
)

export default component.exports